// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-33g2n";
var _3 = "disabled-1jAY3";
var _4 = "header-1RK67";
var _5 = "header__title-1YZlB";
var _6 = "header__price-1Qt7U";
var _7 = "header__icon-196yB";
var _8 = "header__number-3U81r";
var _9 = "content-3w-RW";
var _a = "footer-3Ght1";
var _b = "button-13dJy";
var _c = "button_add-371aC";
export { _1 as "__esModule", _2 as "container", _3 as "disabled", _4 as "header", _5 as "header__title", _6 as "header__price", _7 as "header__icon", _8 as "header__number", _9 as "content", _a as "footer", _b as "button", _c as "button_add" }
export default { "__esModule": _1, "container": _2, "disabled": _3, "header": _4, "header__title": _5, "header__price": _6, "header__icon": _7, "header__number": _8, "content": _9, "footer": _a, "button": _b, "button_add": _c }
